var React = require('react');

function ArrowCircleMd (props) {
    return React.createElement("svg",props,[React.createElement("path",{"d":"M36.7731 19C36.7731 9.29163 28.9029 1.42144 19.1945 1.42144C9.48615 1.42144 1.61597 9.29163 1.61597 19C1.61597 28.7084 9.48615 36.5786 19.1945 36.5786C28.9029 36.5786 36.7731 28.7084 36.7731 19Z","fill":"white","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":0}),React.createElement("path",{"d":"M19.3118 11.1373L19.4888 26.863","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":1}),React.createElement("path",{"d":"M14.7507 15.4665L19.3118 11.1373","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":2}),React.createElement("path",{"d":"M23.6409 15.6984L19.3118 11.1373","strokeWidth":"1.59601","strokeLinecap":"round","strokeLinejoin":"round","key":3})]);
}

ArrowCircleMd.defaultProps = {"viewBox":"0 0 38 38","fill":"none"};

module.exports = ArrowCircleMd;

ArrowCircleMd.default = ArrowCircleMd;
